import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function BancosCreate() {
  const { user } = useContext(AuthContext);
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [banco, setBanco] = useState("");
  const [cuenta, setCuenta] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setBanco("");
    setCuenta("")
  };

  const saveBanco = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_BANCOS,
        {
          banco,
          cuenta
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Cuenta Banco",
            detalle: `${banco} / ${cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea una nueva Cuenta</h3>
        <Form onSubmit={saveBanco}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Banco
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Banco"
              value={banco}
              required
              onChange={(e) => {
                setBanco(e.target.value);
              }}
            />
            <Label for="exampleEmail" className="mr-sm-2">
              Cuenta
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Cuenta"
              value={cuenta}
              required
              onChange={(e) => {
                setCuenta(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuAdmin">
              Regresar
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default BancosCreate;
